import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

const STORAGE_KEY = "zx_cookie_consent_v1";

function updateConsent(state) {
  if (typeof window === "undefined") return;
  const consent = {
    ad_storage: state === "granted" ? "granted" : "denied",
    ad_user_data: state === "granted" ? "granted" : "denied",
    ad_personalization: state === "granted" ? "granted" : "denied",
    analytics_storage: state === "granted" ? "granted" : "denied",
    functionality_storage: "granted",
    security_storage: "granted",
  };
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  gtag("consent", "update", consent);
}

export default function CookieBanner() {
  const { t } = useTranslation();
  const { lang = "ar" } = useParams();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) setVisible(true);
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const decide = (state) => {
    try { localStorage.setItem(STORAGE_KEY, state); } catch (e) {}
    updateConsent(state);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-4 sm:px-6 sm:pb-6"
    >
      <div className="mx-auto max-w-5xl rounded-lg border border-slate-300 bg-white shadow-2xl">
        <div className="flex flex-col gap-4 p-5 sm:p-6 md:flex-row md:items-center md:justify-between">
          <div className="md:max-w-3xl">
            <p className="text-xs font-mono uppercase tracking-widest text-[#C85A32]">
              {t("cookies.title")}
            </p>
            <p className="mt-2 text-sm leading-relaxed text-slate-700">
              {t("cookies.description")}{" "}
              <Link
                to={`/${lang}/cookies`}
                className="font-semibold text-[#0A2540] underline underline-offset-2"
                data-testid="cookie-banner-more-link"
              >
                {t("cookies.more")}
              </Link>
              .
            </p>
          </div>
          <div className="flex flex-col gap-2 sm:flex-row md:shrink-0">
            <button
              data-testid="cookie-banner-reject-btn"
              onClick={() => decide("denied")}
              className="rounded-md border border-slate-300 bg-white px-5 py-2.5 text-sm font-semibold text-[#0A2540] hover:bg-slate-100"
              type="button"
            >
              {t("cookies.reject")}
            </button>
            <button
              data-testid="cookie-banner-accept-btn"
              onClick={() => decide("granted")}
              className="rounded-md bg-[#0A2540] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#0E3358]"
              type="button"
            >
              {t("cookies.accept")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
